import { render } from "./DeliverColis.vue?vue&type=template&id=22e4fd3c&ts=true"
import script from "./DeliverColis.vue?vue&type=script&lang=ts"
export * from "./DeliverColis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__